export default __webpack_public_path__ + "static/media/billable_report_bg.3617392c.png";